import uuidv4 from "uuid/v4";
import moment from "moment";

export const SESSION_STATUS = {
  ACTIVE: "ACTIVE",
  LOCKED: "LOCKED",
  CANCELLED: "CANCELLED",
};

export const CONTEXT_OPTIONS = {
  CALENDAR: "calendar",
  SWIM_LANES: "swimLanes",
  LIST: "list",
};

export const SCHEDULER_PREFERENCE_DEFAULT_VIEW_OPTIONS = [
  {id: CONTEXT_OPTIONS.LIST, description: "List", value: CONTEXT_OPTIONS.LIST},
  {id: CONTEXT_OPTIONS.SWIM_LANES, description: "Swim Lanes", value: CONTEXT_OPTIONS.SWIM_LANES},
  {id: CONTEXT_OPTIONS.CALENDAR, description: "Calendar", value: CONTEXT_OPTIONS.CALENDAR},
]

// State used in day calendar context when locking, creating and modyfying created event slots
export const SLOT_MANIPULATION_OPTIONS = {
  LOCK_SLOT: "lock",
  CREATE_SLOT: "create",
  ASSIGN: "assign",
  RESCHEDULE_LOCKED: "rescheduleLocked",
  RESCHEDULE_PATIENT: "reschedulePatient",
};

export const DAYS_OF_WEEK = [
  { id: "Mon", name: "Mon", value: "1" },
  { id: "Tue", name: "Tue", value: "2" },
  { id: "Wed", name: "Wed", value: "3" },
  { id: "Thu", name: "Thu", value: "4" },
  { id: "Fri", name: "Fri", value: "5" },
  { id: "Sat", name: "Sat", value: "6" },
  { id: "Sun", name: "Sun", value: "7" },
];

export const INIT_ERROR_STATE = {
  startTime: false,
  startDate: false,
  endTime: false,
  endDate: false,
  customTime: {},
  slotDurationInMinutes: false,
};

export const TIME_INTERVAL = [
  { id: "week", name: "Every Week", value: "week" },
  { id: "2week", name: "Every Two Weeks", value: "2week" },
  { id: "3week", name: "Every Three Weeks", value: "3week" },
  { id: "4week", name: "Every Four Weeks", value: "4week" },
];

export const CUSTOM_INTERVAL_OPTIONS = [
  { id: "day", name: "Day", value: "day" },
  { id: "week", name: "Week", value: "week" },
  { id: "month", name: "Month", value: "month" },
];

// export const ERROR_MESSAGES = {
//   interval: "Please provide either custom or default session interval.",
//   daysOfWeekExceedsTimespan: "Days of Week input exceeds timespan between start and end date. To proceed either set valid proper days of week or set one of available intervals."
// }

export const INITIAL_SESSION_STATE = {
  sessionId: uuidv4(),
  daysOfWeek: [], // arr of isoWeekday (string-typed integers)
  customSessionTime: {}, // { [dayOfWeek]: { startTime: null, endTime: null} }
  startTime: moment(),
  startDate: moment(),
  endTime: null,
  endDate: null,
  sessionName: "",
  fixedSlotDuration: false,
  slotDurationInMinutes: "",
  intervalModeOn: true,
  intervalType: null,
  customInterval: false,
  customIntervalNumber: null,
  customIntervalType: null,
  active: true,
  locked: false,
  wardId: "ED",
  clinicsId: "",
  lockedReason: "",
  omitDates: [],
  healthCareService: null,
  assignedSpecialty: null,
  practitioner: null,
  practitionerRole: null,
  newEndDate: moment(),
};

export const APPOINTMENT_SESSION_MODE = {
  BARS: "BaRS",
  ORDINARY: "ordinary",
};

export const APPOINTMENT_MODALS = {
  ASSIGN_SESSION: "assignSession",
  ADD_EDIT_SESSION: "addEditEdSession",
  CHANGE_REVIEW_STATUS: "changeReviewStatus",
  PATIENT_REGISTRY: 'patientRegistry',
  STATUS_TIMELINE: 'statusTimeline',
};

export const APPOINTMENT_PATIENT_STATUSES = {
  STARTED: "started",
  FINISHED: "finished",
  IN_REVIEW: "inReview",
  CANCELLED: "cancelled",
  REGISTERED: "registered",
  NOT_ASSIGNED: "notAssigned",
  UNREGISTERED: "notRegistered",
};

export const TIMER_COUNTDOWN_MINUTES = {
  yellow: 30,
  red: 5,
};

export const DRAG_TYPES = {
  LOCKED: "locked",
  PATIENT: "patient",
  TEMPORARY_LOCKED: "temporaryLocked",
};

export const SLOT_STATUSES = {
  NOT_REGISTERED: { value: 'notRegistered', name: 'Not Arrived' },
  ARRIVED: { value: 'arrived', name: 'Arrived' },
  CALLED: { value: 'called', name: 'Called' },
  BEEING_SEEN: { value: 'beeingSeen', name: 'Being Seen' },
  DEPARTED: { value: 'departed', name: 'Departed' },
  DNA: { value: 'dna', name: 'DNA' },
};
